module.exports = __webpack_public_path__ + "static/media/028.2037753a.jpg";